import React from "react";

export default function Contact() {
    return (
        <section className="s-contact flat-spacing-25">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wg-map">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.2686745923816!2d-0.1403092232724877!3d51.48993691197874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604e17547baf1%3A0xf421b6c6b1052aef!2s17%2C%20Belgrave%20House%2C%2092-94%20Belgrave%20Rd%2C%20Pimlico%2C%20London%20SW1V%202BJ%2C%20Birle%C5%9Fik%20Krall%C4%B1k!5e0!3m2!1str!2str!4v1752593193456!5m2!1str!2str"
                                className="map"
                                style={{border: "none"}}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="content-left">
                            <div className="title fw-medium display-md-2">Contact Us</div>
                            <p className="sub-title text-main">
                                Have a question? Please contact us using the customer support
                                <br/>
                                channels below.
                            </p>
                            <ul className="contact-list">
                                <li>
                                    <p>
                                        Address:{" "}
                                        <a
                                            className="link"
                                            href="https://www.google.com/maps/place/17,+Belgrave+House,+92-94+Belgrave+Rd,+Pimlico,+London+SW1V+2BJ,+United+Kingdom/@51.4899369,-0.1403092,17z"
                                            target="_blank"
                                        >
                                            Flat 17 Belgrave house 92-94 Belgrave road SW1V 2BJ United Kingdom
                                        </a>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Phone number:{" "}
                                        <a className="link" href="tel:+447542447873">
                                            {" "}
                                            +44 7542 447873{" "}
                                        </a>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Email:{" "}
                                        <a className="link" href="mailto:support@luxnco.com">
                                            support@luxnco.com
                                        </a>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Open:{" "}
                                        <span className="text-main"> 9am - 5pm, Mon - Fri </span>
                                    </p>
                                </li>
                            </ul>
                            <ul className="tf-social-icon style-large">
                                <li>
                                    <a
                                        href="https://www.facebook.com/"
                                        className="social-item social-facebook"
                                    >
                                        <i className="icon icon-fb"/>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.instagram.com/"
                                        className="social-item social-instagram"
                                    >
                                        <i className="icon icon-instagram"/>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="content-right">
                            <div className="title fw-medium display-md-2">Get In Touch</div>
                            <p className="sub-title text-main">
                                Please submit&nbsp;all general enquiries&nbsp;in the contact
                                form below and we look forward to hearing from you soon.
                            </p>
                            <div className="form-contact-wrap">
                                <form action="#" className="form-default">
                                    <div className="wrap">
                                        <div className="cols">
                                            <fieldset>
                                                <label htmlFor="username">Your name*</label>
                                                <input
                                                    id="username"
                                                    type="text"
                                                    name="username"
                                                    required
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <label htmlFor="email">Your email*</label>
                                                <input id="email" type="email" name="email" required/>
                                            </fieldset>
                                        </div>
                                        <div className="cols">
                                            <fieldset className="textarea">
                                                <label htmlFor="mess">Message</label>
                                                <textarea id="mess" required defaultValue={""}/>
                                            </fieldset>
                                        </div>
                                        <div className="button-submit">
                                            <button className="tf-btn animate-btn" type="submit">
                                                Send
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
